export default __webpack_public_path__ + "static/media/dependent.c0787525.svg";